/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Verified_ToastInputs */

const en_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription activated successfully!`)
};

const fr_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement active avec succes !`)
};

const de_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement erfolgreich aktiviert!`)
};

const it_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonamento attivato con successo!`)
};

const ru_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка успешно активирована!`)
};

const es_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Suscripción activada exitosamente!`)
};

const zh_cn2_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅已成功激活！`)
};

const ja_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションが正常に有効化されました。`)
};

const hi_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता सफलतापूर्वक सक्रिय हो गई!`)
};

const pt_pt2_creator_checkout_verified_toast = /** @type {(inputs: Creator_Checkout_Verified_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assinatura ativada com sucesso!`)
};

/**
* | output |
* | --- |
* | "Subscription activated successfully!" |
*
* @param {Creator_Checkout_Verified_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verified_toast = /** @type {((inputs?: Creator_Checkout_Verified_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verified_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_checkout_verified_toast(inputs)
	if (locale === "de") return de_creator_checkout_verified_toast(inputs)
	if (locale === "it") return it_creator_checkout_verified_toast(inputs)
	if (locale === "ru") return ru_creator_checkout_verified_toast(inputs)
	if (locale === "es") return es_creator_checkout_verified_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_checkout_verified_toast(inputs)
	if (locale === "ja") return ja_creator_checkout_verified_toast(inputs)
	if (locale === "hi") return hi_creator_checkout_verified_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_checkout_verified_toast(inputs)
	return en_creator_checkout_verified_toast(inputs)
});